import { FileRestoreIcon } from './FileRestoreIcon';

/**
 * author: Google
 * id EE0E5547-D368-43CB-8BDD-7F3774985BEF
 * name file-restore
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-restore.svg
 * tags
 * - Files / Folders 
 */
export const RestorePageIcon = FileRestoreIcon;
export default RestorePageIcon